/**
 * Created by Jew on 3/12/2018.
 */
import {IdexService} from 'app/idex.service';
import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import {LoadingButtonComponent} from '../../shared/loading-button/button';

@Component({
   selector: 'app-edit-etax',
   templateUrl: './setting.component.html',
   styleUrls: ['./setting.component.css']
})
export class SettingEtaxComponent implements OnInit {
   @ViewChild('button') button: LoadingButtonComponent;
   showMailServer: boolean;
   server: string;
   port: any;
   etaxEmail: string;
   etaxPassword: string;

   constructor(@Inject(MAT_DIALOG_DATA) private data: any, private service: IdexService) {
   }

   ngOnInit() {
      this.etaxEmail = this.data.info.username;
      this.etaxPassword = this.data.info.password;
      this.server = this.data.info.server;
      this.port = this.data.info.port;
   }

   detectMailServer(email: any) {
      if (email != null) {
         const i = email.indexOf('@');
         const domain = i === -1 ? '' : email.substr(i + 1);
         this.showMailServer = domain.length > 0 && domain !== 'gmail.com' && domain !== 'outlook.com'
            && domain !== 'hotmail.com' && domain !== 'icloud.com' && domain !== 'yahoo.com';
         if (!this.showMailServer) {
            this.server = '';
            this.port = 993;
         }
      }
   }

   onSave() {
      if (this.etaxEmail !== this.data.info.username ||
         this.etaxPassword !== this.data.info.password ||
         this.server !== this.data.info.server ||
         this.port !== this.data.info.port) {
         const body = {
            username: this.etaxEmail.toLowerCase,
            password: this.etaxPassword,
            server: this.server,
            port: this.port
         };
         this.service.put('/work/' + this.data.business.tin + '/update/info', body)
            .subscribe(
               data => {
                  this.data.business.toast.success(data.message);
                  this.data.business.settingDialog.close();
               }, error =>
                  this.button.reset()
            );
      } else {
         this.data.business.settingDialog.close();
      }
   }
}
